import React from 'react';
import styled from 'styled-components';
import Colors from '../../styles/colors';

const StripePartners = (props) => {
  const {
    promotekit = false,
    linkmink = false, // deprecated
  } = props || {};

  if (!linkmink && !promotekit) {
    return null;
  }

  return (
    <PoweredBy>
      <div className="notice">
        Supported partner{!linkmink || !promotekit ? '' : 's'}
      </div>
      {linkmink && (
        <div className="logo logo-with-120">
          <a href="https://app.linkmink.com/a/soundwise/403" target="_blank">
            <img
              src="../../images/stripe-partner-linkmink.png"
              alt="linkmink"
              title="Affiliate tracking and referral program software for Stripe companies"
            />
          </a>
        </div>
      )}
      {promotekit && (
        <div className="logo">
          <a href="https://soundwise.promotekit.com" target="_blank">
            <img
              src="../../images/stripe-partner-promotekit.png"
              alt="promotekit"
              title="Join Soundwise's affiliate program to earn 30% on referred payments"
            />
          </a>
        </div>
      )}
    </PoweredBy>
  );
};

const PoweredBy = styled.div`
  display:flex;
  align-items: center;
  justify-content: space-between;

  .notice {
    display: flex;
    letter-spacing: 0.01em;
    font-size: 13px;
    color: #000;

    i {
      font-size: 16px;
      padding: 2px 5px 2px 0;
    }
  }

  .logo {
    background-color: ${Colors.mainWhite};
    overflow: hidden;
    width: 138px;
    height: 30px;
    margin-right: -8px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .logo-with-120 {
    width: 120px;
  }
`;

export default StripePartners;
